import { Action, Reducer } from 'redux';
import { CompanyBranchState, CompanyBranchTypes, CompanyBranchActionTypes } from './companyBranchTypes';

export const INITIAL_STATE: CompanyBranchState = {
  companyBranch: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const companyBranchReducer: Reducer<CompanyBranchState> = (
  state: CompanyBranchState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as CompanyBranchActionTypes;
  switch (actionTypes.type) {
    case CompanyBranchTypes.GET_COMPANY_BRANCH:
      return {
        ...state,
        companyBranch: { ...state.companyBranch, isLoading: true }
      };
    case CompanyBranchTypes.SAVE_COMPANY_BRANCH:
      return {
        ...state,
        companyBranch: {
          ...state.companyBranch,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case CompanyBranchTypes.RESET_REDUCER_COMPANY_BRANCH:
      return {
        ...state,
        companyBranch: INITIAL_STATE.companyBranch
      };
    default:
      return state;
  }
};

export default companyBranchReducer;
